(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8412);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_iconly__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5477);
/* harmony import */ var common_tags__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(865);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    border-danger-500\n    hover:border-danger-700\n    focus:ring-0\n    focus:border-danger-700\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    bg-transparent\n    outline-none\n    text-white\n    font-semibold\n    w-full\n    px-4 py-2\n    border-0\n    text-lg md:text-base\n    border-t-0 border-l-0 border-r-0 border-b-2\n    animated\n    focus:ring-0\n    border-bordercolordark\n    hover:border-primary-500\n    hover:border-primary-500\n    focus:border-primary-500\n    focus:border-primary-500\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    bg-transparent\n    text-lg md:text-base\n    w-full\n    px-4 \n    border-0\n    animated\n    outline-none\n    text-black\n    focus:ring-offset-0\n    focus:ring-primary-500\n    focus:ring-opacity-30\n    focus:border-primary-500\n    border  rounded \n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    md:text-sm\n    text-dark-400\n    absolute\n    animated origin-0\n    bottom-3.5 \n    pointer-events-none\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    inline icon-vertical-fix text-danger-500\n    absolute right-4\n    top-1/2 transform -translate-y-1/2\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  inline icon-vertical-fix text-lightGrey dark:text-dark-400 pb-1\n  absolute \n  top-1/2 transform -translate-y-1/2\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    relative\n    ",
        "\n    ",
        "\n    ",
        "\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


// @ts-ignore


var Input = function(_param) {
    var children = _param.children, name = _param.name, disabled = _param.disabled, hint = _param.hint, innerRef = _param.innerRef, startIcon = _param.startIcon, borderLight = _param.borderLight, iconSize = _param.iconSize, _label = _param.label, label = _label === void 0 ? "default label" : _label, placeholder = _param.placeholder, endIcon = _param.endIcon, fullWidth = _param.fullWidth, validation = _param.validation, readOnly = _param.readOnly, showStrength = _param.showStrength, className = _param.className, _type = _param.type, type = _type === void 0 ? "text" : _type, _naked = _param.naked, naked = _naked === void 0 ? false : _naked, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "children",
        "name",
        "disabled",
        "hint",
        "innerRef",
        "startIcon",
        "borderLight",
        "iconSize",
        "label",
        "placeholder",
        "endIcon",
        "fullWidth",
        "validation",
        "readOnly",
        "showStrength",
        "className",
        "type",
        "naked"
    ]);
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(""), 2), innerError = ref[0], setInnerError = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(type), 2), inputType = ref1[0], setInputType = ref1[1];
    var ref2 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(0), 2), strength = ref2[0], setStrength = ref2[1];
    var ref3 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_2__.useState(0), 2), passwordLength = ref3[0], setPasswordLength = ref3[1];
    var error = validation.error;
    react__WEBPACK_IMPORTED_MODULE_2__.useEffect(function() {
        if (error) {
            setInnerError(error.message);
        } else {
            setTimeout(function() {
                setInnerError("");
            }, 300);
        }
    }, [
        error
    ]);
    var inputErrorClasses = (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject());
    var inputClasses = (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject1(), borderLight ? "border-whiteish" : "border-grey-default border-opacity-40", placeholder ? "placeholder-dark-300 font-normal" : "placeholder-transparent", innerError ? inputErrorClasses : "", disabled ? "pointer-events-none" : "", className ? className : "", startIcon ? "pl-12" : "", type === "password" ? "pr-12" : "");
    var inputClassesNaked = (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject2());
    var labelClasses = (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject3(), startIcon ? "left-12" : "left-3.5", innerError ? "text-danger-500" : "");
    var errorIconClasses = (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject4());
    var iconClasses = (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject5());
    var wrapperClasses = (0,common_tags__WEBPACK_IMPORTED_MODULE_3__/* .oneLine */ .f9)(_templateObject6(), fullWidth ? "w-full" : "", innerError ? "text-danger-500" : "", startIcon ? "with-icon" : "");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: "relative z-0 inline-block text-display w-full",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: label !== "" ? "mb-7 mt-6" : "",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: wrapperClasses,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                            ref: innerRef,
                            placeholder: placeholder || label,
                            autoComplete: "off",
                            name: name,
                            readOnly: readOnly,
                            disabled: disabled,
                            className: naked ? inputClassesNaked : inputClasses,
                            type: inputType,
                            onChange: function(el) {
                                setPasswordLength(el.target.value.length);
                            }
                        }, otherProps)),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                            className: labelClasses,
                            children: label
                        }),
                        startIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_iconly__WEBPACK_IMPORTED_MODULE_7__/* .Iconly */ .cr, {
                            name: startIcon,
                            set: "light",
                            size: "small"
                        }),
                        type === "password" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                            onClick: function() {
                                if (inputType === "password") setInputType("text");
                                else setInputType("password");
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_iconly__WEBPACK_IMPORTED_MODULE_7__/* .Iconly */ .cr, {
                                name: "".concat(inputType === "password" ? "Hide" : "Show"),
                                set: "light",
                                primaryColor: "#858D96",
                                size: "medium"
                            })
                        })
                    ]
                }),
                showStrength && passwordLength > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "strength-meter mt-2",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "strength-meter-fill",
                        "data-strength": strength
                    })
                }),
                !naked && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "text-danger-500 w-fit text-xs pt-2 pl-3.5 space-x-1 collapsible-error ".concat(error ? "expanded" : "hidden"),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("p", {
                        className: "inline",
                        children: innerError
                    })
                })
            ]
        })
    });
};
Input.defaultProps = {
    disabled: false,
    validation: {},
    readOnly: false,
    fullWidth: false,
    showStrength: false,
    iconSize: "1rem"
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 8412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/api/ssr/user.ts
var user = __webpack_require__(4765);
// EXTERNAL MODULE: ./src/components/Navbar.tsx
var Navbar = __webpack_require__(7134);
;// CONCATENATED MODULE: ./src/components/ClassicCard.tsx

var ClassicCard = function(param) {
    var otherClasses = param.otherClasses, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-dark-200 rounded-20 ".concat(otherClasses ? otherClasses : ""),
        children: children
    });
};
/* harmony default export */ var components_ClassicCard = (ClassicCard);

// EXTERNAL MODULE: ./node_modules/react-iconly/dist/index.modern.js
var index_modern = __webpack_require__(5477);
// EXTERNAL MODULE: ./src/components/Button.tsx
var Button = __webpack_require__(8663);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(4924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./src/components/Input.tsx
var Input = __webpack_require__(906);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/common-tags/es/index.js + 40 modules
var es = __webpack_require__(865);
;// CONCATENATED MODULE: ./src/components/Dialog.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "fixed z-99999 inset-0 overflow-y-auto"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "flex items-center justify-center h-full pt-4 px-4 text-center sm:p-0"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "fixed inset-0 transition-opacity"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "absolute inset-0 bg-gray-500 opacity-75"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "hidden sm:inline-block sm:align-middle sm:h-screen"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "inline-block align-bottom bg-dark-200 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " p-4 sm:px-6 sm:flex sm:justify-center"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "text-lg w-full text-center leading-6 font-medium text-white"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "bg-dark-200 text-dark-300 px-4 pt-0 "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "sm:flex sm:items-start sm:justify-center"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "mt-3 text-center sm:mt-0 sm:text-left"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "text-sm"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "px-4 py-5 sm:px-6 flex justify-center"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "px-4 py-5 sm:px-6 flex justify-center"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}




var Dialog = function(param) {
    var title = param.title, description = param.description, primaryButton = param.primaryButton, _loading = param.loading, loading = _loading === void 0 ? false : _loading, secondaryButton = param.secondaryButton;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,es/* oneLine */.f9)(_templateObject()),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,es/* oneLine */.f9)(_templateObject1()),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,es/* oneLine */.f9)(_templateObject2()),
                    "aria-hidden": "true",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,es/* oneLine */.f9)(_templateObject3())
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: (0,es/* oneLine */.f9)(_templateObject4()),
                    "aria-hidden": "true",
                    children: "​"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,es/* oneLine */.f9)(_templateObject5()),
                    role: "dialog",
                    "aria-modal": "true",
                    "aria-labelledby": "modal-headline",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,es/* oneLine */.f9)(_templateObject6()),
                            children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (0,es/* oneLine */.f9)(_templateObject7()),
                                id: "modal-headline",
                                children: title
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (0,es/* oneLine */.f9)(_templateObject8()),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,es/* oneLine */.f9)(_templateObject9()),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,es/* oneLine */.f9)(_templateObject10()),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-2 w-full text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: (0,es/* oneLine */.f9)(_templateObject11()),
                                            dangerouslySetInnerHTML: {
                                                __html: description
                                            }
                                        })
                                    })
                                })
                            })
                        }),
                        loading !== true ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,es/* oneLine */.f9)(_templateObject12()),
                            children: [
                                secondaryButton && secondaryButton.buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "secondary",
                                    onClick: secondaryButton.action,
                                    className: "".concat(secondaryButton.className, " sm:w-full sm:mx-3 mr-4"),
                                    children: secondaryButton.buttonText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    fill: "full",
                                    onClick: primaryButton.action,
                                    className: "".concat(primaryButton.className, " sm:w-full sm:mx-3"),
                                    children: primaryButton.buttonText
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (0,es/* oneLine */.f9)(_templateObject13()),
                            children: [
                                secondaryButton && secondaryButton.buttonText && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "secondary",
                                    disabled: true,
                                    onClick: function() {},
                                    className: "".concat(secondaryButton.className, " sm:w-full sm:mx-3 mr-4"),
                                    children: secondaryButton.buttonText
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    color: "primary",
                                    fill: "full",
                                    disabled: true,
                                    onClick: function() {},
                                    className: "".concat(primaryButton.className, " sm:w-full sm:mx-3"),
                                    children: primaryButton.buttonText
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
Dialog.defaultProps = {};
/* harmony default export */ var components_Dialog = (Dialog);

// EXTERNAL MODULE: ./node_modules/dinero.js/build/esm/dinero.js
var esm_dinero = __webpack_require__(711);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.js
var index_esm = __webpack_require__(2283);
// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(8735);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(4231);
// EXTERNAL MODULE: ./src/api/base.ts
var base = __webpack_require__(2690);
// EXTERNAL MODULE: ./src/utils/errorHandling.ts
var errorHandling = __webpack_require__(743);
;// CONCATENATED MODULE: ./src/api/referral/users.ts




var RefferalVia;
(function(RefferalVia) {
    RefferalVia["wire"] = "wire";
    RefferalVia["credits"] = "credits";
})(RefferalVia || (RefferalVia = {}));
var sendRefferalWithdrawCode = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,base/* default */.Z)({
                        method: "post",
                        url: "/withdraw/code",
                        data: values
                    });
                case 3:
                    response = _ctx.sent;
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        status: false,
                        errorMessage: (0,errorHandling/* getErrorMessage */.e)(_ctx.t0)
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function sendRefferalWithdrawCode(values) {
        return _ref.apply(this, arguments);
    };
}();
var sendRefferalWithdrawRequest = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(values) {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,base/* default */.Z)({
                        method: "post",
                        url: "/withdraw/request",
                        data: values
                    });
                case 3:
                    response = _ctx.sent;
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    return _ctx.abrupt("return", {
                        status: false,
                        errorMessage: (0,errorHandling/* getErrorMessage */.e)(_ctx.t0)
                    });
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function sendRefferalWithdrawRequest(values) {
        return _ref.apply(this, arguments);
    };
}();
var getReferralUserData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var response, data;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return (0,base/* default */.Z)({
                        method: "get",
                        url: "/me/stats"
                    });
                case 3:
                    response = _ctx.sent;
                    data = response.data;
                    return _ctx.abrupt("return", data);
                case 8:
                    _ctx.prev = 8;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error(_ctx.t0);
                case 11:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                8
            ]
        ]);
    }));
    return function getReferralUserData() {
        return _ref.apply(this, arguments);
    };
}();
var getRefereesData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sort, filter, pagination) {
        var params, response, referees;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    params = {
                        order_by: sort.order_by ? sort.order_by : null,
                        order_type: sort.order_type ? sort.order_type : null,
                        filter_by: filter.filter_by ? filter.filter_by : null,
                        filter_value: filter.filter_value ? filter.filter_value : null,
                        limit: pagination.limit ? pagination.limit : 10,
                        skip: pagination.skip ? pagination.skip : 0
                    };
                    _ctx.next = 4;
                    return (0,base/* default */.Z)({
                        method: "get",
                        url: "/me/referees",
                        params: params
                    });
                case 4:
                    response = _ctx.sent;
                    referees = [];
                    response.data.referees.forEach(function(referee) {
                        var r = {
                            user: referee.referee_email,
                            status: referee.referee_status ? "Active" : "Inactive",
                            registered_at: referee.date,
                            activated_at: referee.date_activated
                        };
                        referees.push(r);
                    });
                    return _ctx.abrupt("return", {
                        data: referees,
                        totalRows: response.data.total_count,
                        status: {
                            active: response.data.active_count,
                            inactive: response.data.inactive_count
                        }
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error(_ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function getRefereesData(sort, filter, pagination) {
        return _ref.apply(this, arguments);
    };
}();
var getReferralTransactionsData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sort, filter, pagination) {
        var params, response, referees;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    params = {
                        order_by: sort.order_by ? sort.order_by : null,
                        order_type: sort.order_type ? sort.order_type : null,
                        filter_by: filter.filter_by ? filter.filter_by : null,
                        filter_value: filter.filter_value ? filter.filter_value : null,
                        limit: pagination.limit ? pagination.limit : 10,
                        skip: pagination.skip ? pagination.skip : 0
                    };
                    _ctx.next = 4;
                    return (0,base/* default */.Z)({
                        method: "get",
                        url: "/me/transactions",
                        params: params
                    });
                case 4:
                    response = _ctx.sent;
                    referees = [];
                    response.data.transactions.forEach(function(transaction) {
                        var r = {
                            actions: transaction.transaction_data,
                            amount: transaction.transaction_value,
                            date: transaction.transaction_date,
                            type: transaction.transaction_type
                        };
                        referees.push(r);
                    });
                    return _ctx.abrupt("return", {
                        data: referees,
                        totalRows: response.data.total[0].count
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error(_ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function getReferralTransactionsData(sort, filter, pagination) {
        return _ref.apply(this, arguments);
    };
}();
var getFinancialsData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(sort, filter, pagination) {
        var params, response, withdraws;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    params = {
                        order_by: sort.order_by ? sort.order_by : null,
                        order_type: sort.order_type ? sort.order_type : null,
                        filter_by: filter.filter_by ? filter.filter_by : null,
                        filter_value: filter.filter_value ? filter.filter_value : null,
                        limit: pagination.limit ? pagination.limit : 10,
                        skip: pagination.skip ? pagination.skip : 0
                    };
                    _ctx.next = 4;
                    return (0,base/* default */.Z)({
                        method: "get",
                        url: "/withdraw/list",
                        params: params
                    });
                case 4:
                    response = _ctx.sent;
                    withdraws = [];
                    response.data.transactions.forEach(function(transaction) {
                        var r = {
                            withdraw_via: transaction.withdraw_via,
                            withdraw_value: transaction.withdraw_value,
                            withdraw_status: transaction.withdraw_status,
                            withdraw_datetime: transaction.withdraw_datetime,
                            withdraw_details: transaction.withdraw_details.email
                        };
                        withdraws.push(r);
                    });
                    return _ctx.abrupt("return", {
                        data: withdraws,
                        totalRows: response.data.total.count
                    });
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](0);
                    throw new Error(_ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                10
            ]
        ]);
    }));
    return function getFinancialsData(sort, filter, pagination) {
        return _ref.apply(this, arguments);
    };
}();
var JWT = {
    getReferralUserData: getReferralUserData,
    getRefereesData: getRefereesData,
    getReferralTransactionsData: getReferralTransactionsData,
    getFinancialsData: getFinancialsData,
    sendRefferalWithdrawCode: sendRefferalWithdrawCode,
    sendRefferalWithdrawRequest: sendRefferalWithdrawRequest
};
/* harmony default export */ var users = (JWT);

// EXTERNAL MODULE: ./src/components/app.tsx + 3 modules
var app = __webpack_require__(61);
;// CONCATENATED MODULE: ./src/components/WithdrawModal.tsx


















var WithdrawModal = function(param) {
    var otherClasses = param.otherClasses, closeAction = param.closeAction, currentBalance = param.currentBalance, onSucessfulWithdrawRequest = param.onSucessfulWithdrawRequest;
    var notify = (0,app/* useApp */.q)().notify;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), paymentMethod = ref[0], setPaymentMethod = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), creditsValue = ref1[0], setCreditsValue = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), wireValue = ref2[0], setWireValue = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState("custom"), 2), withdrawOption = ref3[0], setWithdrawOption = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), showDialog = ref4[0], setShowDialog = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), loadingSaveCampaign = ref5[0], setLoadingSaveCampaign = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState(), 2), file = ref6[0], setFile = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState(1), 2), step = ref7[0], setStep = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), tooltipCredits = ref8[0], setTooltipCredits = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), tooltipWire = ref9[0], setTooltipWire = ref9[1];
    var validationSchema = yup_es/* object */.Ry().shape({
        email: yup_es/* string */.Z_().email("This is not a valid email address").when("paymentMethod", {
            is: RefferalVia.credits,
            then: yup_es/* string */.Z_().required("Field is mandatory")
        }),
        amount: yup_es/* number */.Rx().required("Field is mandatory").positive().min(1, "The minimum amount is one"),
        confirmationCode: yup_es/* string */.Z_().when("stepForm", {
            is: "2",
            then: yup_es/* string */.Z_().required("Field is mandatory")
        })
    });
    var useYupValidationResolver = function(schema) {
        return (0,react.useCallback)(function() {
            var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
                var values, _type, r;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            _ctx.next = 3;
                            return schema.validate(data, {
                                abortEarly: false
                            });
                        case 3:
                            values = _ctx.sent;
                            return _ctx.abrupt("return", {
                                values: values,
                                errors: {}
                            });
                        case 7:
                            _ctx.prev = 7;
                            _ctx.t0 = _ctx["catch"](0);
                            ;
                            r = {
                                values: {},
                                errors: _ctx.t0.inner.reduce(function(allErrors, currentError) {
                                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, allErrors), (0,_define_property/* default */.Z)({}, currentError.path, {
                                        type: (_type = currentError.type) !== null && _type !== void 0 ? _type : "validation",
                                        message: currentError.message
                                    }));
                                }, {})
                            };
                            return _ctx.abrupt("return", r);
                        case 12:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        7
                    ]
                ]);
            }));
            return function(data) {
                return _ref.apply(this, arguments);
            };
        }(), [
            schema
        ]);
    };
    var resolver = useYupValidationResolver(validationSchema);
    var ref10 = (0,index_esm/* useForm */.cI)({
        resolver: resolver
    }), register = ref10.register, getValues = ref10.getValues, setError = ref10.setError, formState = ref10.formState, control = ref10.control, setValue = ref10.setValue, errors = ref10.errors, handleSubmit = ref10.handleSubmit;
    var paymentMethods = [
        {
            imageSrc: "/images/wiretransfer.svg",
            title: "Wire Transfer",
            subtitle: "",
            selector: RefferalVia.wire,
            available: true,
            tooltipText: "wire"
        },
        {
            imageSrc: "/images/blindspot-credits.svg",
            title: "Blindspot Credits",
            subtitle: "Get 25% extra value",
            selector: RefferalVia.credits,
            available: true,
            tooltipText: "credits"
        }, 
    ];
    var withdrawOptions = [
        {
            title: "Custom amount",
            selector: "custom"
        },
        {
            title: "The whole amount",
            selector: "whole"
        }, 
    ];
    (0,react.useEffect)(function() {
        if (withdrawOption === "whole") {
            setValue("amount", (0,esm_dinero/* default */.Z)({
                amount: Number(currentBalance),
                precision: 4,
                currency: "USD"
            }).toFormat().replace("$", ""), {
                shouldValidate: false,
                shouldDirty: false
            });
            if (currentBalance) setCreditsValue(Math.round(Number(currentBalance) + Number(currentBalance) * 0.25));
            setWireValue(Math.round(Number(currentBalance)));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        withdrawOption
    ]);
    var primaryButton = {
        buttonText: "Withdraw",
        action: (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        handleSubmit(onSubmit);
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))
    };
    var secondaryButton = {
        buttonText: "Cancel",
        action: function() {
            setShowDialog(false);
        }
    };
    var onSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(data) {
            var values, codeResponse, valuesStep2, codeResponse1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!loadingSaveCampaign) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 2:
                        if (!(step === 1 && paymentMethod)) {
                            _ctx.next = 13;
                            break;
                        }
                        values = {
                            via: paymentMethod,
                            amount: data.amount * 10000,
                            details: {
                                email: data.email,
                                iban: data.iban
                            }
                        };
                        _ctx.next = 6;
                        return users.sendRefferalWithdrawCode(values);
                    case 6:
                        codeResponse = _ctx.sent;
                        if (!(codeResponse && codeResponse.all === "good")) {
                            _ctx.next = 12;
                            break;
                        }
                        setStep(2);
                        setValue("stepForm", 2);
                        notify("We sent you an email with the confirmation code for withdraw request!", "success", "top-right");
                        return _ctx.abrupt("return");
                    case 12:
                        if (!codeResponse.status) {
                            notify(codeResponse.errorMessage, "error", "top-right");
                        }
                    case 13:
                        if (!(step === 2 && paymentMethod && data.confirmationCode)) {
                            _ctx.next = 24;
                            break;
                        }
                        valuesStep2 = {
                            via: paymentMethod,
                            amount: data.amount * 10000,
                            code: data.confirmationCode,
                            details: {
                                email: data.email,
                                iban: data.iban
                            }
                        };
                        _ctx.next = 17;
                        return users.sendRefferalWithdrawRequest(valuesStep2);
                    case 17:
                        codeResponse1 = _ctx.sent;
                        if (!(codeResponse1 && codeResponse1.all === "good")) {
                            _ctx.next = 23;
                            break;
                        }
                        onSucessfulWithdrawRequest();
                        notify("Withdrawal request successful", "success", "top-right");
                        closeAction();
                        return _ctx.abrupt("return");
                    case 23:
                        if (!codeResponse1.status) {
                            notify(codeResponse1.errorMessage, "error", "top-right");
                        }
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function onSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    var dirtyFields = formState.dirtyFields;
    var getValidation = function(inputName) {
        var val = {
            isDirty: dirtyFields[inputName],
            error: setError[inputName]
        };
        return val;
    };
    var handleChange = function(event) {
        setFile(event.target.files[0]);
        setValue("file", event.target.files, {
            shouldValidate: true,
            shouldDirty: true
        });
    };
    var onChangePaymentMethod = function(element) {
        if (element && element.available && step === 1) {
            setPaymentMethod(element.selector);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-dark-200 rounded-20 max-w-[679px] ".concat(otherClasses ? otherClasses : ""),
        children: [
            tooltipCredits && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                id: "tooltip-payment-method",
                place: "top",
                className: "custom-tooltip",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                    children: [
                        "If you choose to transfer your balance to ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "Blindspot Credits"
                        }),
                        ", these will be credited in your account and you will be able to use that amount to advertise on ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: "over 500.000 digital billboards"
                        }),
                        "  all across the world.",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: " And you get 25% extra value for money!"
                        })
                    ]
                })
            }),
            tooltipWire && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {
                id: "tooltip-payment-method",
                place: "top",
                className: "custom-tooltip",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                    children: "After submitting the withdraw request, we will send you an email with all the necessary details to complete the withdraw process!"
                })
            }),
            showDialog && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Dialog, {
                title: "Final Check",
                loading: loadingSaveCampaign,
                primaryButton: primaryButton,
                secondaryButton: secondaryButton,
                description: "You're about to withdraw <strong>".concat((0,esm_dinero/* default */.Z)({
                    amount: Number(currentBalance),
                    precision: 4,
                    currency: "USD"
                }).toFormat(), "</strong>, to <strong>").concat(paymentMethod, "!</strong><br><br/>An email will be sent to your email address. \n        <br><br/>Please confirm withdrow from your email!")
            }, "1"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "mb-3 text-xl text-white fonst-semibold",
                children: "Thanks for sharing Blindspot to the world!"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                className: "text-dark-300 mb-7",
                children: [
                    "Your current value of your balance is",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "font-semibold text-white",
                        children: (0,esm_dinero/* default */.Z)({
                            amount: Number(currentBalance),
                            precision: 4,
                            currency: "USD"
                        }).toFormat()
                    }),
                    ". Choose your preferred payment method."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row tablet:flex-col tablet:space-y-4 mb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "w-4/12 text-white fonst-semibold",
                                children: "Withdraw to"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row justify-start w-full tablet:flex-col tablet:space-y-4",
                                children: paymentMethods.map(function(el, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(paymentMethod === el.selector ? "border border-primarydark-default" : "border border-dark-200", " ").concat(el.available ? "cursor-pointer" : "", " relative bg-dark-400 bg-opacity-20 h-24 w-40 tablet:w-full rounded-20 p-4 flex flex-col justify-between mr-4 tablet:mr-0"),
                                        onClick: function() {
                                            setValue("paymentMethod", el.selector, {
                                                shouldValidate: true,
                                                shouldDirty: true
                                            });
                                            onChangePaymentMethod(el);
                                        },
                                        children: [
                                            el.tooltipText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "info-mark",
                                                "data-tip": true,
                                                "data-for": "tooltip-payment-method",
                                                onMouseLeave: function() {
                                                    el.tooltipText === "wire" ? setTooltipWire(false) : setTooltipCredits(false);
                                                },
                                                onMouseEnter: function() {
                                                    el.tooltipText === "wire" ? setTooltipWire(true) : setTooltipCredits(true);
                                                },
                                                children: "i"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row items-start justify-between",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: el.imageSrc
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "".concat(paymentMethod === el.selector ? "border-2 border-primarydark-default" : "", " rounded-full bg-white w-4 h-4 flex items-center justify-center"),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "".concat(paymentMethod === el.selector ? "bg-primarydark-default" : "", " rounded-full bg-white w-2 h-2")
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-row flex-nowrap",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                    className: "text-xs font-semibold mr-1",
                                                    children: el.subtitle
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-xs",
                                                children: el.title
                                            })
                                        ]
                                    }, "".concat(index, "_").concat(el.selector));
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "hidden",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                name: "paymentMethod",
                                type: "hidden",
                                innerRef: register,
                                validation: getValidation("paymentMethod"),
                                placeholder: "Insert your email",
                                label: "",
                                fullWidth: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                name: "stepForm",
                                type: "hidden",
                                innerRef: register,
                                validation: getValidation("stepForm"),
                                placeholder: "Insert your email",
                                label: "",
                                fullWidth: true
                            })
                        ]
                    }),
                    paymentMethod && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-7",
                                children: paymentMethod === RefferalVia.wire ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-dark-300",
                                    children: "After submitting the withdraw request, we will send you an email with all the necessary details to complete the withdraw process!"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                    className: "text-dark-300",
                                    children: [
                                        "If you choose to transfer your balance to ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "Blindspot Credits"
                                        }),
                                        ", these will be credited in your account and you will be able to use that amount to advertise on ",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "over 500.000 digital billboards"
                                        }),
                                        "  all across the world.",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: " And you get 25% extra value for money!"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: " flex-row tablet:flex-col tablet:space-y-4 mb-7 ".concat(paymentMethod === RefferalVia.wire ? "hidden" : "", " "),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "w-4/12 mt-3 text-white fonst-semibold tablet:w-full",
                                        children: "Add email"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-row justify-start w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            name: "email",
                                            type: "email",
                                            innerRef: register,
                                            validation: getValidation("email"),
                                            placeholder: "Insert Blindspot account email to receive credits",
                                            label: "",
                                            fullWidth: true,
                                            readOnly: step === 2
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row mb-7 tablet:flex-col tablet:space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "w-4/12 mt-3 text-white fonst-semibold tablet:w-full",
                                        children: "Amount to withdraw"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col justify-start w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex flex-row tablet:flex-col tablet:space-y-4 mb-7",
                                                children: withdrawOptions.map(function(el, index) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "".concat(withdrawOption === el.selector ? "border border-primarydark-default" : "", " px-3 py-2 bg-dark-400 bg-opacity-20 flex flex-row items-center justify-arround mr-3 rounded-2xl cursor-pointer"),
                                                        onClick: function() {
                                                            if (step === 1) {
                                                                setWithdrawOption(el.selector);
                                                            }
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "".concat(withdrawOption === el.selector ? "border-2 border-primarydark-default" : "", " rounded-full bg-white w-4 h-4 mr-3 flex items-center justify-center"),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "".concat(withdrawOption === el.selector ? "bg-primarydark-default" : "", " rounded-full bg-white w-2 h-2")
                                                                })
                                                            }),
                                                            el.title
                                                        ]
                                                    }, "".concat(index, "_").concat(el.selector));
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                                        name: "amount",
                                                        type: "number",
                                                        step: "0.01",
                                                        min: "1",
                                                        validation: getValidation("amount"),
                                                        placeholder: "Insert amount to withdraw",
                                                        label: "",
                                                        innerRef: register,
                                                        fullWidth: true,
                                                        readOnly: withdrawOption === "whole" || step === 2 ? true : false,
                                                        onChange: function(el) {
                                                            var val = Number(el.target.value);
                                                            setCreditsValue(Math.round((val + val * 0.25) * 10000));
                                                            setWireValue(Math.round(val * 10000));
                                                        }
                                                    }),
                                                    paymentMethod === RefferalVia.credits ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute top-2 right-0",
                                                        children: [
                                                            "(~",
                                                            (0,esm_dinero/* default */.Z)({
                                                                amount: Number(creditsValue),
                                                                precision: 4,
                                                                currency: "USD"
                                                            }).toFormat(),
                                                            " ",
                                                            "credits)"
                                                        ]
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "absolute top-2 right-0",
                                                        children: [
                                                            "(",
                                                            (0,esm_dinero/* default */.Z)({
                                                                amount: Number(wireValue),
                                                                precision: 4,
                                                                currency: "USD"
                                                            }).toFormat(),
                                                            ")"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step === 2 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row mb-7 tablet:flex-col tablet:space-y-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: "w-4/12 mt-3 text-white fonst-semibold tablet:w-full",
                                        children: "Confirmation code"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex flex-col justify-start w-full",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* default */.Z, {
                                            name: "confirmationCode",
                                            type: "text",
                                            validation: getValidation("confirmationCode"),
                                            placeholder: "Insert confirmation code",
                                            label: "",
                                            innerRef: register,
                                            fullWidth: true
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row tablet:flex-col tablet:space-y-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "mr-4 tablet:order-last tablet:mt-4",
                                type: "submit",
                                color: "secondary",
                                fullWidth: true,
                                onClick: closeAction,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                type: "submit",
                                color: "primary",
                                fullWidth: true,
                                children: "Withdraw"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_WithdrawModal = (WithdrawModal);

;// CONCATENATED MODULE: ./src/components/Popup.tsx

function Popup_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "fixed z-100 inset-0 overflow-y-auto"
    ]);
    Popup_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Popup_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "flex items-center justify-center min-h-screen bg-dark-default bg-opacity-60"
    ]);
    Popup_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Popup_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "inline-block bg-dark-200 rounded-3xl text-left overflow-hidden shadow-modal transform transition-all p-7 m-7"
    ]);
    Popup_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Popup_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        " pb-3 flex align-center justify-between border-b border-dark-300 border-opacity-40"
    ]);
    Popup_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Popup_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "text-lg  font-normal text-dark-400"
    ]);
    Popup_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Popup_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "text-lg  font-bold text-body cursor-pointer ease-in-out transition duration-300 hover:rotate-180"
    ]);
    Popup_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function Popup_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "w-40vw rounded-3xl overflow-hidden pt-4"
    ]);
    Popup_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var Popup = function(param) {
    var title = param.title, children = param.children, closeAction = param.closeAction;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,es/* oneLine */.f9)(Popup_templateObject()),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,es/* oneLine */.f9)(Popup_templateObject1()),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,es/* oneLine */.f9)(Popup_templateObject2()),
                role: "dialog",
                "aria-modal": "true",
                "aria-labelledby": "modal-headline",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (0,es/* oneLine */.f9)(Popup_templateObject3()),
                        children: [
                            title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: (0,es/* oneLine */.f9)(Popup_templateObject4()),
                                id: "modal-headline",
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (0,es/* oneLine */.f9)(Popup_templateObject5()),
                                "aria-hidden": "true",
                                onClick: closeAction,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                    width: "30",
                                    height: "30",
                                    viewBox: "0 0 30 30",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                        d: "M8.98959 9.01041L21.0104 21.0312M21.0104 9.01041L8.98959 21.0312",
                                        stroke: "#A7ACB3",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,es/* oneLine */.f9)(Popup_templateObject6()),
                        children: children
                    })
                ]
            })
        })
    });
};
Popup.defaultProps = {};
/* harmony default export */ var components_Popup = (Popup);

// EXTERNAL MODULE: ./node_modules/react-spinners/PulseLoader.js
var PulseLoader = __webpack_require__(2105);
var PulseLoader_default = /*#__PURE__*/__webpack_require__.n(PulseLoader);
;// CONCATENATED MODULE: ./src/components/BudgetWidget.tsx



/* @ts-ignore */ 






var BudgetWidget = function(param) {
    var loader = param.loader, title = param.title, value = param.value, value2 = param.value2, label = param.label, label2 = param.label2, before = param.before, after = param.after, icon = param.icon, ltr = param.ltr, _withdraw = param.withdraw, withdraw = _withdraw === void 0 ? false : _withdraw, otherClass = param.otherClass, _dinero = param.dinero, dinero = _dinero === void 0 ? false : _dinero, onSucessfulWithdrawRequest = param.onSucessfulWithdrawRequest;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isOpen = ref[0], setIsOpen = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_ClassicCard, {
                otherClasses: "px-5 py-4 shadow-card flex flex-row tablet:flex-col tablet:items-start justify-between items-center ".concat(otherClass ? otherClass : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex items-center  ".concat(ltr ? "flex-row-reverse" : ""),
                        children: [
                            icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex items-center px-5 h-16 bg-grey-200 text-dark-400 bg-opacity-20 rounded-4xl py-5 mr-3",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Iconly */.cr, {
                                    name: icon,
                                    set: "curved",
                                    size: "medium"
                                })
                            }) || "",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col justify-center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        className: "text-lg md:text-sm text-lightGrey dark:text-dark-400",
                                        children: title
                                    }),
                                    !loader ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                                        className: "flex items-end text-xl text-white flex flex-wrap",
                                        children: [
                                            before && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "font-thin",
                                                children: before
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                className: "font-semibold md:font-bold",
                                                children: dinero && (0,esm_dinero/* default */.Z)({
                                                    amount: Number(value),
                                                    precision: 4,
                                                    currency: "USD"
                                                }).toFormat() || value
                                            }),
                                            value2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-row items-end whitespace-nowrap",
                                                children: [
                                                    dinero && value2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        className: " text-dark-300 mx-2",
                                                        children: " | "
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                        className: "font-semibold md:font-bold warning-text",
                                                        children: dinero && value2 && (0,esm_dinero/* default */.Z)({
                                                            amount: Number(value2),
                                                            precision: 4,
                                                            currency: "USD"
                                                        }).toFormat()
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "warning-text text-sm ml-1 font-semibold md:font-bold",
                                                        children: label2
                                                    })
                                                ]
                                            }) : "",
                                            after && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "text-lg md:text-sm ml-1",
                                                children: after
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((PulseLoader_default()), {
                                            color: "#eeeff0",
                                            size: 8,
                                            loading: true
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "tablet:mx-auto",
                        children: withdraw && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            className: "tablet:mt-7 whitespace-nowrap",
                            onClick: function() {
                                return setIsOpen(true);
                            },
                            type: "submit",
                            color: "secondary",
                            fill: "outline",
                            fullWidth: true,
                            children: "Request Cash Out"
                        }) || ""
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Popup, {
                title: "Withdraw request",
                closeAction: function() {
                    setIsOpen(false);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_WithdrawModal, {
                    currentBalance: value,
                    closeAction: function() {
                        setIsOpen(false);
                    },
                    onSucessfulWithdrawRequest: function() {
                        onSucessfulWithdrawRequest();
                    }
                })
            })
        ]
    });
};
/* harmony default export */ var components_BudgetWidget = (BudgetWidget);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/react-data-table-component/dist/index.cjs.js
var index_cjs = __webpack_require__(44);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@iconify/react-with-api/dist/icon.esm.js
var icon_esm = __webpack_require__(8213);
;// CONCATENATED MODULE: ./src/components/RadioBox.tsx





function RadioBox_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-danger-500\n"
    ]);
    RadioBox_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RadioBox_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex rounded-xl  overflow-hidden flex-wrap \n  items-stretch\n  ",
        "\n"
    ]);
    RadioBox_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RadioBox_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "select-box-label"
    ]);
    RadioBox_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RadioBox_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "select-box-label absolute"
    ]);
    RadioBox_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RadioBox_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "radioButtonList ",
        "  ",
        ""
    ]);
    RadioBox_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RadioBox_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "text-danger-500 w-fit text-xs pt-2 space-x-1 collapsible-error ",
        ""
    ]);
    RadioBox_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}




var getColor = function(color) {
    switch(color){
        case "primary":
            return "checked:bg-primary-500 focus:bg-primary-500 text-primary-500 focus:ring-primary-500";
        case "accent":
            return "checked:bg-accent-500 focus:bg-accent-500 text-accent-500 focus:ring-accent-500";
        case "warn":
            return "checked:bg-warn-500 focus:bg-warn-500 text-warn-500 focus:ring-warn-500";
        case "danger":
            return "checked:bg-danger-500 focus:bg-danger-500 text-danger-500 focus:ring-danger-500";
        case "success":
            return "checked:bg-success-500 focus:bg-success-500 text-success-500 focus:ring-success-500";
        case "neutral":
            return "checked:bg-neutral-500 focus:bg-neutral-500 text-neutral-500 focus:ring-neutral-500";
        default:
            return "checked:bg-primary-500 focus:bg-primary-500 text-primary-500 focus:ring-primary-500";
    }
};
var RadioBox = function(_param) {
    var innerRef = _param.innerRef, disabled = _param.disabled, validation = _param.validation, name = _param.name, _boxSize = _param.boxSize, boxSize = _boxSize === void 0 ? "big" : _boxSize, options = _param.options, justIcons = _param.justIcons, isDark = _param.isDark, _type = _param.type, type = _type === void 0 ? "radio" : _type, flexClass = _param.flexClass, labelSmall = _param.labelSmall, label = _param.label, otherClasses = _param.otherClasses, simpleCheckbox = _param.simpleCheckbox, otherProps = (0,_object_without_properties/* default */.Z)(_param, [
        "innerRef",
        "disabled",
        "validation",
        "name",
        "boxSize",
        "options",
        "justIcons",
        "isDark",
        "type",
        "flexClass",
        "labelSmall",
        "label",
        "otherClasses",
        "simpleCheckbox"
    ]);
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), innerError = ref[0], setInnerError = ref[1];
    var error = validation.error;
    react.useEffect(function() {
        if (error) {
            setInnerError(error.message);
        } else {
            setTimeout(function() {
                setInnerError("");
            }, 300);
        }
    }, [
        error
    ]);
    var inputErrorClasses = (0,es/* oneLine */.f9)(RadioBox_templateObject());
    var inputClasses = (0,es/* oneLine */.f9)(RadioBox_templateObject1(), options.length === 1 ? "border-4 border-dark-100 shadow-card" : "bg-dark-default px-2 py-1");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "space-y-4",
        children: [
            label && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (0,es/* oneLine */.f9)(RadioBox_templateObject2()),
                children: label
            }),
            labelSmall && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                className: (0,es/* oneLine */.f9)(RadioBox_templateObject3()),
                children: labelSmall
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,es/* oneLine */.f9)(RadioBox_templateObject4(), inputClasses, justIcons ? "just-icons bg-whiteish dark:bg-dark-default md:rounded-xl rounded-3xl" : ""),
                children: options.map(function(el, key) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                ref: innerRef,
                                defaultChecked: el.checked,
                                type: type,
                                name: name,
                                value: el.value,
                                disabled: el.disabled,
                                className: "hidden"
                            }, otherProps), {
                                id: "".concat(key, "_").concat(el.value, "_").concat(name)
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                className: "".concat(boxSize, " ").concat(el.disabled ? "is-disabled" : "", " ").concat(el.icon ? "flex" : "", " ").concat(otherClasses ? otherClasses : "", " dark:text-dark-400"),
                                htmlFor: "".concat(key, "_").concat(el.value, "_").concat(name),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "w-full text-center",
                                    children: el.label
                                })
                            })
                        ]
                    }, "".concat(key, "_").concat(el.value));
                })
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (0,es/* oneLine */.f9)(RadioBox_templateObject5(), error ? "expanded" : ""),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(icon_esm/* Icon */.JO, {
                        className: "inline icon-vertical-fix",
                        height: "1rem",
                        width: "1rem",
                        icon: "ant-design:exclamation-circle-outlined"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "inline",
                        children: innerError
                    })
                ]
            })
        ]
    });
};
RadioBox.defaultProps = {
    disabled: false,
    validation: {},
    readOnly: false
};
/* harmony default export */ var components_RadioBox = (RadioBox);

// EXTERNAL MODULE: ./node_modules/react-date-range/dist/styles.css
var styles = __webpack_require__(1541);
// EXTERNAL MODULE: ./node_modules/react-date-range/dist/theme/default.css
var theme_default = __webpack_require__(2049);
;// CONCATENATED MODULE: ./src/components/TablesActions.tsx





 // main style file
 // theme css file
var TablesActions = function(param) {
    var tablesList = param.tablesList, selectedTable = param.selectedTable, applyFilter = param.applyFilter, selectTable = param.selectTable, statusUsers = param.statusUsers;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState("all"), 2), transType = ref[0], setTransType = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection"
        }
    ]), 2), stateDatePicker = ref2[0], setStateDatePicker = ref2[1];
    react.useEffect(function() {}, [
        stateDatePicker
    ]);
    var transTypeOptions = [
        {
            title: "All",
            value: "all"
        },
        {
            title: "Collected",
            value: "credited"
        },
        {
            title: "Withdraw",
            value: "debited"
        }
    ];
    var handleSelect = function(ranges) {
        console.log(ranges);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClassicCard, {
            otherClasses: "p-5 mt-7",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "w-full flex flex-row tablet:flex-col items-center tablet:space-y-7 relative z-50 justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "w-fit mobile:w-full",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RadioBox, {
                            onChange: function(e) {
                                selectTable(e.target.value);
                            },
                            justIcons: false,
                            boxSize: "small",
                            name: "primary",
                            options: tablesList,
                            label: ""
                        }, "1")
                    }),
                    selectedTable === "transactions" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-row justify-between text-dark-300",
                            children: transTypeOptions.map(function(el, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "cursor-pointer ".concat(index !== 0 ? "pl-10" : "", " ").concat(transType == el.value ? "text-white font-semibold" : ""),
                                    onClick: function() {
                                        setTransType(el.value);
                                        applyFilter(el.value, "transaction_type");
                                    },
                                    children: el.title
                                }, index);
                            })
                        })
                    }),
                    selectedTable === "users" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-row",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row items-center px-7 border-r-2 border-dark-300 border-opacity-20 text-dark-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-4 h-4 border border-success-500 border-opacity-50 rounded-full mr-4 flex flex-row items-center justify-center flex-shrink-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-2 h-2 bg-success-500 rounded-full"
                                        })
                                    }),
                                    statusUsers.active,
                                    " active"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "px-7 flex flex-row items-center text-dark-400",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "w-4 h-4 border border-primarydark-default border-opacity-50 rounded-full mr-4 flex flex-row items-center justify-center flex-shrink-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "w-2 h-2 bg-primarydark-default rounded-full"
                                        })
                                    }),
                                    statusUsers.inactive,
                                    " inactive"
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var components_TablesActions = (TablesActions);

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 34 modules
var format = __webpack_require__(2167);
;// CONCATENATED MODULE: ./src/components/NoDataTable.tsx




 // main style file
 // theme css file
var NoDataTable = function(param) {
    var selectedTable = param.selectedTable;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), warining = ref[0], setWarining = ref[1];
    (0,react.useEffect)(function() {
        switch(selectedTable){
            case "transactions":
                setWarining({
                    img: "transactionsNoData.svg",
                    text: "You don't have any updates to your balance yet. Here you can track the details of any updates to your balance, whether you receive money or withdraw it."
                });
                break;
            case "users":
                setWarining({
                    img: "usersNoData.svg",
                    text: "Currently, you have not referred any users. Use the referral link above to refer users and start earning money. Here you can see all the users you have referred and check whether they are active (at least a 500$ campaign), or not."
                });
                break;
            case "financials":
                setWarining({
                    img: "financialNoData.svg",
                    text: "You don't have any withdrawal requests registered yet. If you want to withdraw your accumulated earnings, request a withdrawal, and here you can track the status and history of your withdrawals."
                });
                break;
            default:
                setWarining({
                    img: "financialNoData.svg",
                    text: "You don't have any withdrawal requests registered yet. If you want to withdraw your accumulated earnings, request a withdrawal, and here you can track the status and history of your withdrawals."
                });
        }
    }, [
        selectedTable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_ClassicCard, {
            otherClasses: "p-7 m-7",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full flex flex-row tablet:flex-col items-center justify-center py-7 relative z-50",
                children: warining && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "md:w-6/12",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: "block mx-auto left-animation md:px-4",
                            src: "/".concat(warining.img),
                            alt: "nousers"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            className: "text-dark-300 text-center mt-5",
                            children: warining.text
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var components_NoDataTable = (NoDataTable);

;// CONCATENATED MODULE: ./src/components/Tables.tsx





function Tables_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    flex flex-col justify-start\n    h-full line-container\n  "
    ]);
    Tables_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tables_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    text-sm\n    text-white\n    h-full \n    flex items-center\n    w-full  \n    flex-row \n    justify-start \n    flex-wrap\n    line-container\n  "
    ]);
    Tables_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Tables = function(count) {
    var lineContainerClasses = (0,es/* oneLine */.f9)(Tables_templateObject());
    var valueClasses = (0,es/* oneLine */.f9)(Tables_templateObject1());
    var getStatusClases = function(status) {
        if (status === "Inactive") {
            return "text-primarydark-default bg-primarydark-default bg-opacity-20 rounded-2xl px-4 py-1";
        } else {
            if (status === "pending") {
                return "text-warn-500 bg-warn-default bg-opacity-20 rounded-2xl px-4 py-1";
            } else {
                if (status === "denied") {
                    return "text-danger-500 bg-danger-500 bg-opacity-20 rounded-2xl px-4 py-1";
                } else {
                    return "text-success-500 bg-success-500 bg-opacity-20 rounded-2xl px-4 py-1";
                }
            }
        }
    };
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([
        {
            value: "transactions",
            icon: "",
            label: "Balance",
            checked: true,
            pagination: {
                limit: 10,
                skip: 0
            },
            sort: {
                order_by: "",
                order_type: ""
            },
            filter: {
                filter_by: "",
                filter_value: ""
            }
        },
        {
            value: "users",
            icon: "",
            label: "Users",
            checked: false,
            pagination: {
                limit: 10,
                skip: 0
            },
            sort: {
                order_by: "",
                order_type: ""
            },
            filter: {
                filter_by: "",
                filter_value: ""
            }
        },
        {
            value: "financials",
            icon: "",
            label: "Withdraws",
            checked: false,
            pagination: {
                limit: 10,
                skip: 0
            },
            sort: {
                order_by: "",
                order_type: ""
            },
            filter: {
                filter_by: "",
                filter_value: ""
            }
        }, 
    ]), 2), tablesList = ref[0], setTablesList = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), columns = ref1[0], setColumns = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), tableData = ref2[0], setTableData = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState(""), 2), selectedTable = ref3[0], setSelectedTabel = ref3[1];
    var ref4 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), usersTable = ref4[0], setUsersTable = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), financialsTable = ref5[0], setFinancialsTable = ref5[1];
    var ref6 = (0,_sliced_to_array/* default */.Z)(react.useState({}), 2), statusUsers = ref6[0], setStatusUsers = ref6[1];
    var ref7 = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), transactionsTable = ref7[0], setTransactionsTable = ref7[1];
    var ref8 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), totalRowsTrans = ref8[0], setTotalRowsTrans = ref8[1];
    var ref9 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), totalRowsUsers = ref9[0], setTotalRowsUsers = ref9[1];
    var ref10 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), totalRowsFinancials = ref10[0], setTotalRowsFinancials = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), usedFilters = ref11[0], setUsedFilters = ref11[1];
    var ref12 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), loader = ref12[0], setLoader = ref12[1];
    react.useEffect(function() {
        getTablesData();
    }, [
        tablesList
    ]);
    react.useEffect(function() {
        getTransactions();
        getFinancials();
    }, [
        count
    ]);
    react.useEffect(function() {
        if (selectedTable === "") {
            var ref;
            var defaultSelectedTable = tablesList.filter(function(table) {
                return table.checked === true;
            });
            setDisplayType(((ref = defaultSelectedTable[0]) === null || ref === void 0 ? void 0 : ref.value) || tablesList[0].value);
        } else {
            setDisplayType(selectedTable);
        }
    }, [
        usersTable,
        transactionsTable,
        financialsTable
    ]);
    var getTablesData = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (selectedTable === "" || selectedTable === "transactions") {
                            getTransactions();
                        }
                        if (selectedTable === "" || selectedTable === "users") {
                            getUsers();
                        }
                        if (selectedTable === "" || selectedTable === "financials") {
                            getFinancials();
                        }
                    case 3:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getTablesData() {
            return _ref.apply(this, arguments);
        };
    }();
    var getTransactions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var responseTransactions;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return users.getReferralTransactionsData(tablesList[0].sort, tablesList[0].filter, tablesList[0].pagination);
                    case 2:
                        responseTransactions = _ctx.sent;
                        setTransactionsTable(responseTransactions.data);
                        setTotalRowsTrans(responseTransactions.totalRows);
                        setLoader(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getTransactions() {
            return _ref.apply(this, arguments);
        };
    }();
    var getUsers = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var responseUsers;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return users.getRefereesData(tablesList[1].sort, tablesList[1].filter, tablesList[1].pagination);
                    case 2:
                        responseUsers = _ctx.sent;
                        setUsersTable(responseUsers.data);
                        setTotalRowsUsers(responseUsers.totalRows);
                        setStatusUsers(responseUsers.status);
                        setLoader(false);
                    case 7:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUsers() {
            return _ref.apply(this, arguments);
        };
    }();
    var getFinancials = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var responseUsers;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return users.getFinancialsData(tablesList[2].sort, tablesList[2].filter, tablesList[2].pagination);
                    case 2:
                        responseUsers = _ctx.sent;
                        setFinancialsTable(responseUsers.data);
                        setTotalRowsFinancials(responseUsers.totalRows);
                        setLoader(false);
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getFinancials() {
            return _ref.apply(this, arguments);
        };
    }();
    var columnsTransactions = [
        {
            name: "Actions",
            selector: "actions",
            sortable: false,
            accessor: "actions",
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Action:"
                            }),
                            props.actions
                        ]
                    })
                });
            }
        },
        {
            name: "Amount",
            selector: "transaction_value",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Amount:"
                            }),
                            props.type === "debited" ? "-" : "+",
                            (0,esm_dinero/* default */.Z)({
                                amount: Math.ceil(props.amount ? props.amount : 0),
                                precision: 4,
                                currency: "USD"
                            }).toFormat()
                        ]
                    })
                });
            }
        },
        {
            name: "Date",
            selector: "transaction_date",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Date:"
                            }),
                            props.date && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: (0,format/* default */.Z)(new Date(props.date), "dd.MM.yyyy hh:mm")
                            })
                        ]
                    })
                });
            }
        }
    ];
    var columnsFinancials = [
        {
            name: "Type",
            selector: "withdraw_via",
            sortable: true,
            accessor: "withdraw_via",
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "capitalize ".concat(valueClasses),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Type:"
                            }),
                            props.withdraw_via === "credits" ? "Blindspot Credits" : props.withdraw_via === "wire" ? "Wire Transfer" : props.withdraw_via
                        ]
                    })
                });
            }
        },
        {
            name: "Value",
            selector: "withdraw_value",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Amount:"
                            }),
                            (0,esm_dinero/* default */.Z)({
                                amount: Math.ceil(props.withdraw_value ? props.withdraw_value : 0),
                                precision: 4,
                                currency: "USD"
                            }).toFormat()
                        ]
                    })
                });
            }
        },
        {
            name: "Status",
            selector: "withdraw_status",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Status:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "capitalize cursor-pointer ".concat(getStatusClases(props.withdraw_status != null ? props.withdraw_status : "pending"), " "),
                                children: props.withdraw_status != null ? props.withdraw_status : "Pending"
                            })
                        ]
                    })
                });
            }
        },
        {
            name: "Details",
            selector: "withdraw_details",
            sortable: true,
            accessor: "withdraw_details",
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: props.withdraw_via === "credits" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(valueClasses),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Details:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mr-1",
                                children: (0,esm_dinero/* default */.Z)({
                                    amount: Math.ceil(props.withdraw_value ? props.withdraw_value : 0) + 25 / 100 * Math.ceil(props.withdraw_value ? props.withdraw_value : 0),
                                    precision: 4,
                                    currency: "USD"
                                }).toFormat()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "text-dark-300 mr-1",
                                children: [
                                    " ",
                                    " credits sent to:"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-dark-400",
                                children: props.withdraw_details
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "".concat(valueClasses),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Details:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "mr-1",
                                children: (0,esm_dinero/* default */.Z)({
                                    amount: Math.ceil(props.withdraw_value ? props.withdraw_value : 0),
                                    precision: 4,
                                    currency: "USD"
                                }).toFormat()
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                className: "text-dark-300 mr-1",
                                children: [
                                    " ",
                                    " added to your acount"
                                ]
                            })
                        ]
                    })
                });
            }
        },
        {
            name: "Date",
            selector: "withdraw_datetime",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Date:"
                            }),
                            props.withdraw_datetime && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: (0,format/* default */.Z)(new Date(props.withdraw_datetime), "dd.MM.yyyy hh:mm")
                            })
                        ]
                    })
                });
            }
        }
    ];
    var columnsUsers = [
        {
            name: "User",
            selector: "referee_email",
            sortable: true,
            accessor: "referee_email",
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cursor-pointer ".concat(valueClasses),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "User:"
                            }),
                            props.user
                        ]
                    })
                });
            }
        },
        {
            name: "Status",
            selector: "referee_status",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Status:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: getStatusClases(props.status),
                                children: props.status
                            })
                        ]
                    })
                });
            }
        },
        {
            name: "Registered at",
            selector: "registered_at",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Registered at:"
                            }),
                            props.registered_at && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: (0,format/* default */.Z)(new Date(props.registered_at), "dd.MM.yyyy hh:mm")
                            })
                        ]
                    })
                });
            }
        },
        {
            name: "Activated at",
            selector: "activated_at",
            sortable: true,
            cell: function(props) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: lineContainerClasses,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: valueClasses,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "col-label-mobile",
                                children: "Activated at:"
                            }),
                            props.activated_at ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                children: (0,format/* default */.Z)(new Date(props.activated_at), "dd.MM.yyyy hh:mm")
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-dark-300",
                                children: "Not yet activated ( at least a 500$ campaign )"
                            })
                        ]
                    })
                });
            }
        }, 
    ];
    var setDisplayType = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(table) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (table === "users") {
                            setColumns(columnsUsers);
                            setTableData(usersTable);
                        }
                        if (table === "transactions") {
                            setColumns(columnsTransactions);
                            setTableData(transactionsTable);
                        }
                        if (table === "financials") {
                            setColumns(columnsFinancials);
                            setTableData(financialsTable);
                        }
                        setSelectedTabel(table);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function setDisplayType(table) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSort = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(column, sortDirection) {
            var localList, tabel, index;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localList = (0,_to_consumable_array/* default */.Z)(tablesList);
                        if (column && column.selector) {
                            tabel = localList.filter(function(el) {
                                return el.value === selectedTable;
                            })[0];
                            if (tabel) {
                                tabel.sort.order_by = column.selector;
                                tabel.sort.order_type = sortDirection;
                            }
                            index = localList.indexOf(tabel);
                            if (index > -1) {
                                localList[index] = tabel;
                            }
                            setTablesList(localList);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSort(column, sortDirection) {
            return _ref.apply(this, arguments);
        };
    }();
    var hadleFilter = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(filter_value, filter_by) {
            var localList, tabel, index;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localList = (0,_to_consumable_array/* default */.Z)(tablesList);
                        if (filter_value && filter_by) {
                            tabel = localList.filter(function(el) {
                                return el.value === selectedTable;
                            })[0];
                            if (tabel) {
                                if (filter_value !== "all") {
                                    setUsedFilters(true);
                                    tabel.filter.filter_value = filter_value;
                                    tabel.filter.filter_by = filter_by;
                                } else {
                                    setUsedFilters(false);
                                    tabel.filter.filter_value = null;
                                    tabel.filter.filter_by = null;
                                }
                            }
                            index = localList.indexOf(tabel);
                            if (index > -1) {
                                localList[index] = tabel;
                            }
                            setTablesList(localList);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function hadleFilter(filter_value, filter_by) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleRowsPerPage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(rows) {
            var localList, tabel, index;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localList = (0,_to_consumable_array/* default */.Z)(tablesList);
                        if (rows) {
                            tabel = localList.filter(function(el) {
                                return el.value === selectedTable;
                            })[0];
                            if (tabel) {
                                tabel.pagination.limit = rows;
                                tabel.pagination.skip = 0;
                            }
                            index = localList.indexOf(tabel);
                            if (index > -1) {
                                localList[index] = tabel;
                            }
                            setTablesList(localList);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleRowsPerPage(rows) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleChangePage = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(page) {
            var localList, tabel, index;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        localList = (0,_to_consumable_array/* default */.Z)(tablesList);
                        if (page) {
                            tabel = localList.filter(function(el) {
                                return el.value === selectedTable;
                            })[0];
                            if (tabel) {
                                tabel.pagination.skip = page - 1;
                            }
                            index = localList.indexOf(tabel);
                            if (index > -1) {
                                localList[index] = tabel;
                            }
                            setTablesList(localList);
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleChangePage(page) {
            return _ref.apply(this, arguments);
        };
    }();
    var getTotalRowsTabel = function() {
        switch(selectedTable){
            case "users":
                return totalRowsUsers;
            case "transfers":
                return totalRowsTrans;
            case "financials":
                return totalRowsFinancials;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TablesActions, {
                tablesList: tablesList,
                selectTable: function(table) {
                    return setDisplayType(table);
                },
                applyFilter: function(filter_value, filter_by) {
                    return hadleFilter(filter_value, filter_by);
                },
                selectedTable: selectedTable,
                statusUsers: statusUsers
            }),
            !loader ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-dark-200 rounded-20",
                children: tableData && tableData.length > 0 || usedFilters === true ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_cjs/* default */.ZP, {
                    noHeader: true,
                    className: "table-simulate",
                    pagination: true,
                    paginationPerPage: 10,
                    onSort: handleSort,
                    sortServer: true,
                    columns: columns,
                    data: tableData,
                    paginationServer: true,
                    onChangeRowsPerPage: handleRowsPerPage,
                    onChangePage: handleChangePage,
                    paginationTotalRows: getTotalRowsTabel()
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_NoDataTable, {
                    selectedTable: selectedTable
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-dark-200 rounded-20 flex flex-row items-center justify-center min-h-[350px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((PulseLoader_default()), {
                    color: "#eeeff0",
                    size: 20,
                    loading: true
                })
            })
        ]
    });
};
/* harmony default export */ var components_Tables = (Tables);

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./src/pages/index.tsx














var ReferralPage = function(_ctx) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), userInfo = ref[0], setUserInfo = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(0), 2), updateTables = ref1[0], setUpdateTables = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), loader = ref2[0], setLoader = ref2[1];
    var notify = (0,app/* useApp */.q)().notify;
    react.useEffect(function() {
        (0,user/* checkUser */.z)();
        getUserInfo();
    }, []);
    react.useEffect(function() {
        if (userInfo) {
            setLoader(false);
        } else {
            setLoader(true);
        }
    }, [
        userInfo
    ]);
    var getUserInfo = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
            var userInfo;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return users.getReferralUserData();
                    case 2:
                        userInfo = _ctx.sent;
                        setUserInfo(userInfo);
                    case 4:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function getUserInfo() {
            return _ref.apply(this, arguments);
        };
    }();
    var steps = [
        {
            title: "Step 1 - Share your unique referral link",
            description: "People who click on it will be attributed to your link and you’ll be able to track how many sign up in this dashboard.",
            icon: "/images/step1.svg"
        },
        {
            title: "Step 2 - People join Blindspot using your link and get a gift",
            description: "Users you refer will receive $25 worth of credits, so that’s just another reason to recommend people to use your link!",
            icon: "/images/step2.svg"
        },
        {
            title: "Step 3 - Get paid",
            description: "If a user you recommended to us creates their first successful campaign worth at least $500, you’ll receive $100 and you’ll be able to track all your rewards here. You can cash out using the “Cash Out” button in this dashboard.",
            icon: "images/step3.svg"
        }, 
    ];
    var budgetWidgets = [
        {
            loader: loader,
            otherClass: "w-3/12 mr-7 tablet:w-full tablet:mb-7",
            title: "Total earnings",
            value: userInfo ? userInfo.alltime : 0,
            dinero: true,
            after: "",
            icon: "Wallet"
        },
        {
            loader: loader,
            otherClass: "w-3/12 mr-7 tablet:w-full tablet:mb-7",
            title: "Total referrals",
            value: userInfo ? userInfo.referee_count.count : 0,
            dinero: false,
            after: "",
            icon: "People"
        },
        {
            loader: loader,
            otherClass: "w-6/12 tablet:w-full tablet:mb-7",
            title: "Current balance",
            value: userInfo ? userInfo.balance : 0,
            label: "available",
            value2: userInfo ? userInfo.hold : 0,
            label2: "on hold",
            dinero: true,
            after: "",
            icon: "Chart",
            withdraw: true
        }, 
    ];
    var onCopyToClipboard = function() {
        var selBox = document.createElement("textarea");
        selBox.style.position = "fixed";
        selBox.style.left = "0";
        selBox.style.top = "0";
        selBox.style.opacity = "0";
        selBox.value = "https://portal.seeblindspot.com/auth/register?refId=".concat(userInfo.referrer_code);
        document.body.appendChild(selBox);
        selBox.focus();
        selBox.select();
        document.execCommand("copy");
        document.body.removeChild(selBox);
        notify("The link has been copied to clipboard!", "success");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: userInfo ? "Referral | Blindspot" : "Log In - Blindspot Referrals"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {
                title: "Referral Program",
                logout: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex space-y-7 flex-col px-7 pt-7 pb-20 tablet:px-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "bg-dark-200 rounded-20 w-full flex flex-col p-5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-row tablet:flex-col pb-7 border-b-2 border-dark-300 border-opacity-20 justify-between",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col w-1/2 tablet:w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "font-semibold mb-4 text-xl",
                                                children: "Spread the word, get the dough"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                className: "text-dark-300",
                                                children: "Use your personalized link to send users to the Blindspot Platform. This link is unique to you and will track the number of users you refer to Blindspot and create a campaign."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row w-5/12 tablet:w-full items-center tablet:mt-7",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "bg-grey-default overflow-x-auto bg-opacity-20 rounded-20 rounded-r-none p-4 w-10/12 tablet:w-10/12 relative",
                                                children: [
                                                    !loader && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                        className: "whitespace-nowrap",
                                                        children: [
                                                            "https://portal.seeblindspot.com/auth/register?refId=",
                                                            userInfo ? userInfo.referrer_code : ""
                                                        ]
                                                    }),
                                                    loader && /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "text-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((PulseLoader_default()), {
                                                            color: "#eeeff0",
                                                            size: 8,
                                                            loading: true
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "bg-primarydark-default w-2/12 rounded-20 rounded-l-none p-4 flex justify-center items-center cursor-pointer hover:shadow-primaryOutlineHover focus:shadow-primaryOutlineHover border-2 border-primarydark-default",
                                                onClick: onCopyToClipboard,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* PaperDownload */.q7, {
                                                            size: 18,
                                                            set: "light"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "ml-2 tablet:hidden text-sm font-semibold",
                                                        children: "Copy"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex flex-row tablet:flex-col w-full pt-7 tablet:space-y-7",
                                children: steps.map(function(step, key) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-row w-4/12 tablet:w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "referral-icon-container flex-shrink-0 rounded-full border border-dark-300 border-opacity-40 mr-4 tablet:ml-0",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "m-auto p-3",
                                                    src: step.icon
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col mr-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "font-semibold mb-2 text-lg",
                                                        children: step.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                                        className: "text-dark-300",
                                                        children: step.description
                                                    })
                                                ]
                                            })
                                        ]
                                    }, key);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row tablet:flex-col pb-7 tablet:pb-0 border-b-2 border-dark-300 border-opacity-20 ",
                        children: budgetWidgets.map(function(widget, key) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_BudgetWidget, {
                                otherClass: widget.otherClass,
                                title: widget.title,
                                value: widget.value,
                                value2: widget.value2,
                                label: widget.label,
                                label2: widget.label2,
                                dinero: widget.dinero,
                                after: "",
                                icon: widget.icon,
                                withdraw: widget.withdraw,
                                loader: loader,
                                onSucessfulWithdrawRequest: function() {
                                    getUserInfo();
                                    setUpdateTables(+1);
                                }
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Tables, {
                        count: updateTables
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var pages = (ReferralPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [111,749,364,956,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);